var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12C2.5 6.75329 6.7533 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12Z",
    stroke: "#171D27",
    className: "info-circles"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.25C11.59 10.25 11.25 10.59 11.25 11L11.25 16C11.25 16.41 11.59 16.75 12 16.75C12.41 16.75 12.75 16.41 12.75 16L12.75 11C12.75 10.59 12.41 10.25 12 10.25Z",
    fill: "#171D27",
    className: "info-circlef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.08 8.37999C11.13 8.5 11.2 8.60999 11.29 8.70999C11.39 8.79999 11.5 8.86999 11.62 8.91999C11.86 9.02 12.14 9.02 12.38 8.92C12.5 8.87 12.61 8.8 12.71 8.71C12.8 8.61 12.87 8.5 12.92 8.38C12.97 8.26 13 8.13 13 8C13 7.87 12.97 7.74 12.92 7.62C12.87 7.49 12.8 7.39 12.71 7.29C12.61 7.2 12.5 7.12999 12.38 7.07999C12.26 7.02999 12.13 6.99999 12 6.99999C11.87 6.99999 11.74 7.02999 11.62 7.07999C11.5 7.12999 11.39 7.2 11.29 7.29C11.2 7.39 11.13 7.49 11.08 7.62C11.03 7.74 11 7.86999 11 7.99999C11 8.12999 11.03 8.25999 11.08 8.37999Z",
    fill: "#171D27",
    className: "info-circlef"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.67ede8fa1adf93afb51d138ce48efd96.svg";
export { ForwardRef as ReactComponent };